const parsePageField = (value, fallback = {}) => {
	if (!value) return fallback;
	if (typeof value === 'object') return value;

	try {
		return JSON.parse(value);
	} catch (error) {
		return fallback;
	}
};

const normalizePageField = value => {
	if (value == null || typeof value === 'string') return value;
	return JSON.stringify(value);
};

export const parsePage = page => ({
	...page,
	body: parsePageField(page.body),
	theme: parsePageField(page.theme),
});

export const normalizePage = page => ({
	...page,
	body: normalizePageField(page.body),
	theme: normalizePageField(page.theme),
});
